import { TableCell, Typography } from '@pinwheel/origami';
import React from 'react';
export var TableLabelCell = function (_a) {
    var children = _a.children;
    return (React.createElement(TableCell, { color: "default" },
        React.createElement(Typography, { color: "light", variant: "caption", as: "span" }, children)));
};
export var TableValueCell = function (_a) {
    var children = _a.children;
    return (React.createElement(TableCell, { color: "default", align: "right" },
        React.createElement(Typography, { variant: "caption", weight: "bold", as: "span" }, children)));
};
